import { IconButtonLink } from "@/components/ui/Link";
import { Box } from "@givenwell/components";
import { ChevronLeftIcon } from "@givenwell/core-solid-icons";
import { styled } from "@givenwell/stitches";
import { colors, fonts } from "@givenwell/theme";
import { createFileRoute, useCanGoBack, useRouter } from "@tanstack/react-router";
import html from "./member-terms.html?raw";

export const Route = createFileRoute("/policies/terms")({
  component: Page,
});

function Page() {
  const canGoBack = useCanGoBack();
  const router = useRouter();
  return (
    <Box
      css={{
        maxWidth: 800,
        margin: "0 auto",
        pt: "max(16px, var(--safe-area-inset-top))",
        pl: "max(16px, var(--safe-area-inset-left))",
        pr: "max(16px, var(--safe-area-inset-right))",
        pb: "max(16px, var(--safe-area-inset-bottom))",
      }}
    >
      <Box
        css={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: "var(--safe-area-inset-top)",
          backgroundColor: colors.cream,
        }}
      />
      <IconButtonLink
        to="/"
        replace
        variant="plain"
        color="neutral"
        aria-label="Back"
        onClick={() => canGoBack && router.history.back()}
      >
        <ChevronLeftIcon />
      </IconButtonLink>
      <Prose dangerouslySetInnerHTML={{ __html: html }} />
    </Box>
  );
}

const Prose = styled("div", {
  textAlign: "justify",
  textWrap: "pretty",

  "& h1": {
    fontSize: 48,
    weight: 700,
    textAlign: "left",
    mb: 16,
    textWrap: "balance",
    fontFamily: fonts.ftHabit,
    lineHeight: 1,
  },

  li: {
    // add spacing between item and marker
    ml: -8,
    pl: 8,
  },
  // Begin nested list item numbering trick
  ol: {
    counterReset: "item",
    listStyleType: "none",
  },
  "ol>li": {
    counterIncrement: "item",
    my: "1.5em",
  },
  "ol>li::marker": {
    content: "counters(item, '.') '. '",
  },
  // end nested list item numbering trick

  "& ol ol ol": {
    listStyleType: "lower-alpha",
    pl: 30,
    "& ol": {
      listStyleType: "lower-roman",
    },
    "& > li::marker": {
      content: "unset",
    },
  },
  "ul li": {
    // add spacing between item and marker
    ml: -16,
    pl: 16,
  },

  pl: 32,
});
